var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxArchiveIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.706 5.292L18.707 2.293C18.6143 2.19996 18.5041 2.12617 18.3828 2.07589C18.2614 2.0256 18.1313 1.99981 18 2H6C5.86866 1.99981 5.73857 2.0256 5.61724 2.07589C5.4959 2.12617 5.38571 2.19996 5.293 2.293L2.294 5.292C2.20057 5.38468 2.12647 5.49498 2.076 5.61652C2.02553 5.73805 1.9997 5.8684 2 6V19C2 20.103 2.897 21 4 21H20C21.103 21 22 20.103 22 19V6C22.0003 5.8684 21.9745 5.73805 21.924 5.61652C21.8735 5.49498 21.7994 5.38468 21.706 5.292ZM6.414 4H17.586L18.586 5H5.414L6.414 4ZM4 19V7H20L20.002 19H4Z",
    fill: "#74788D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9H10V12H7L12 17L17 12H14V9Z",
    fill: "#F1B44C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxArchiveIn);
export default __webpack_public_path__ + "static/media/bx-archive-in.55b678594e574d702490fab42a396444.svg";
export { ForwardRef as ReactComponent };